function initiateGifts() {
  // Don't re-parse if we already have it
  if (window.cartGiftData) return

  const scriptElement = document.getElementById("data-ajax-freebies")
  if (!scriptElement) return

  const jsonString = scriptElement.textContent
  if (!jsonString) return

  try {
    window.cartGiftData = JSON.parse(jsonString)
  } catch (error) {
    console.error("Failed to parse #data-ajax-freebies JSON:", error)
  }
}

function computeTotalItemsWithoutGift(cart) {
  if (!cart?.items?.length) return 0

  return cart.items.reduce((acc, item) => {
    if (item.price === 0) return acc

    const isPackageProtection = item.sku === "x-redo"
    if (isPackageProtection) return acc

    if (item.properties && item.properties["_add_more_save_more"]) return acc + item.quantity

    return acc
  }, 0)
}

function isSubscriptionCartLine(item) {
  if (!item) return false
  return Boolean(item.selling_plan_allocation) || item.selling_plan != null
}

/**
 * Shopify cart/update.js cannot safely set qty by variant id when duplicate
 * variant lines exist. Use cart/change.js (line item key) for those; bulk
 * update only for variants that appear on exactly one cart line.
 */
function buildCartLineQuantityRequests(cart, qtyByVariantId) {
  const requests = []
  const bulkUpdates = Object.create(null)

  if (!cart?.items?.length) return requests

  for (const [rawVid, quantity] of Object.entries(qtyByVariantId)) {
    const variantId = Number(rawVid)
    if (!Number.isFinite(variantId)) continue

    const qty = Number(quantity)
    if (!Number.isFinite(qty)) continue

    const matchingItems = cart.items.filter((item) => Number(item.variant_id) === variantId)
    if (!matchingItems.length) continue

    const subscriptionLines = matchingItems.filter(isSubscriptionCartLine)
    const regularLines = matchingItems.filter((item) => !isSubscriptionCartLine(item))

    for (const item of subscriptionLines) {
      if (Number(item.quantity) === qty) continue
      const lineKey = item.key != null ? String(item.key).trim() : ""
      if (!lineKey) continue
      requests.push({
        type: "change",
        body: { id: lineKey, quantity: qty },
        info: { is_automatic: true },
      })
    }

    if (regularLines.length === 1 && matchingItems.length === 1) {
      bulkUpdates[String(variantId)] = qty
    } else if (regularLines.length > 0) {
      // Same variant on multiple lines (e.g. BOGO paid/free legs or one-time
      // + subscription) — cart/update.js by variant id is ambiguous; target
      // each intended line by key instead.
      for (const item of regularLines) {
        if (Number(item.quantity) === qty) continue
        const lineKey = item.key != null ? String(item.key).trim() : ""
        if (!lineKey) continue
        requests.push({
          type: "change",
          body: { id: lineKey, quantity: qty },
          info: { is_automatic: true },
        })
      }
    }
  }

  if (Object.keys(bulkUpdates).length > 0) {
    requests.push({
      type: "update",
      body: { updates: bulkUpdates },
      info: { is_automatic: true },
    })
  }

  return sanitizeCartMutationRequests(requests)
}

function sanitizeCartMutationRequests(requests) {
  if (!Array.isArray(requests) || !requests.length) return []

  return requests.filter((request) => {
    if (!request?.type || !request.body) return false

    if (request.type === "change") {
      const lineKey = request.body.id != null ? String(request.body.id).trim() : ""
      const quantity = Number(request.body.quantity)
      return Boolean(lineKey) && Number.isFinite(quantity)
    }

    if (request.type === "update") {
      const updates = request.body.updates
      return updates && typeof updates === "object" && Object.keys(updates).length > 0
    }

    return false
  })
}

function tryBeforeYouBuy() {
  const cart = window.liquidAjaxCart?.cart
  if (!cart?.items?.length || !cart.token) return null

  // Pair map: placeholder -> real product variant
  const PAIRS = [
    { placeholderId: 47489608908965, productId: 45998318813349 }, // White Tea 2 pack
    { placeholderId: 47489608941733, productId: 45998318878885 }, // Citrus 2 pack
    { placeholderId: 47489608974501, productId: 45998318846117 }, // Sweet Amber 2 pack
    { placeholderId: 47541781725349, productId: 45960968339621 }, // White Tea 1 pack
    { placeholderId: 47541781758117, productId: 45960963522725 }, // Citrus 1 pack
    { placeholderId: 47541781790885, productId: 45960968372389 }, // Sweet Amber 1 pack
  ]

  try {
    const qtyByVariantId = new Map()

    for (const item of cart.items) {
      const vid = Number(item.variant_id)
      qtyByVariantId.set(vid, Number(item.quantity || 0))
    }

    const updates = Object.create(null)

    for (const { placeholderId, productId } of PAIRS) {
      const placeholderQty = qtyByVariantId.get(placeholderId)
      const productQty = qtyByVariantId.get(productId)

      const hasPlaceholder = typeof placeholderQty === "number"
      const hasProduct = typeof productQty === "number"

      // Rule: placeholder cannot exist without product
      if (hasPlaceholder && !hasProduct) {
        if (placeholderQty !== 0) {
          updates[placeholderId] = 0
        }
        continue
      }

      // Rule: if both exist, placeholder must match product qty (product wins)
      if (hasPlaceholder && hasProduct && placeholderQty !== productQty) {
        updates[placeholderId] = productQty
      }
    }

    const requests = buildCartLineQuantityRequests(cart, updates)
    if (!requests.length) return null

    return { requests }
  } catch (error) {
    console.error("Error in tryBeforeYouBuy:", error)
  }
}

function CartGiftMutation() {
  const gifts = window.cartGiftData
  const cart = window.liquidAjaxCart?.cart

  if (!gifts?.freebies?.length || !cart?.items?.length || !cart.token) return

  try {
    window.totalItemsWithoutGift = computeTotalItemsWithoutGift(cart)

    const totalPrice = cart.total_price / 100
    const variantIdsInCart = new Set(cart.items.map((item) => Number(item.variant_id)))
    const updates = Object.create(null)

    for (const freebie of gifts.freebies) {
      const freebieVariantId = Number(freebie.product)
      if (!Number.isFinite(freebieVariantId)) continue
      if (!variantIdsInCart.has(freebieVariantId)) continue
      if (freebie.threshold == null || !(freebie.threshold > totalPrice)) continue

      updates[freebieVariantId] = 0
    }

    const requests = buildCartLineQuantityRequests(cart, updates)
    if (!requests.length) return

    return { requests }
  } catch (error) {
    console.error("Error in CartGiftMutation:", error)
  }
}

document.addEventListener("liquid-ajax-cart:request-end", (event) => {
  const { requestState, cart } = event.detail

  if (cart?.items) {
    window.totalItemsWithoutGift = computeTotalItemsWithoutGift(cart)
  }

  // add-to-cart succeeded
  if (requestState.requestType !== "add" || !requestState.responseData?.ok) return

  // avoid opening drawer over upsell
  if (document.querySelector(".pre-upsell__wrapper.show")) return

  if (requestState.info?.should_keep_drawer_closed) return

  const drawer = document.querySelector("cart-drawer")
  if (!drawer) return

  // Upsell adds while the drawer is already open — skip re-open/focus churn.
  if (drawer.hasAttribute("open")) return

  // Bug 3 (2026-05-21): defensive guard against the "drawer opens then
  // immediately closes" report from collection/page ATC. Only auto-open
  // when the cart `item_count` actually grew. If the cart didn't change
  // (e.g. a duplicate request-end fired from a follow-up mutation like
  // CartGiftMutation / tryBeforeYouBuy, or the add was a server-side no-op),
  // we skip the open call — preventing the second open() from racing the
  // first one's slide-in animation and unmounting / re-mounting the
  // drawer mid-animation. We compare against the prior count cached on
  // window so the check works across multiple successive ATC clicks.
  const prevCount = Number(window.__bbePrevCartItemCount)
  const newCount = Number(cart?.item_count)
  if (Number.isFinite(prevCount) && Number.isFinite(newCount) && newCount <= prevCount) {
    if (Number.isFinite(newCount)) window.__bbePrevCartItemCount = newCount
    return
  }
  if (Number.isFinite(newCount)) window.__bbePrevCartItemCount = newCount

  // Force-clear any stale user-closed flag so an earlier session close
  // can't block this open. `open()` clears it too, but redundancy here
  // shields against any code path that mutates the attribute between
  // request-end and the next animation frame.
  if (drawer.dataset.userClosed === "true") {
    delete drawer.dataset.userClosed
  }

  drawer.open()
})

// Seed the cached count so the very first ATC isn't gated by "no prior count".
if (typeof window.__bbePrevCartItemCount === "undefined") {
  document.addEventListener("liquid-ajax-cart:init", (event) => {
    const initialCount = Number(event?.detail?.cart?.item_count)
    if (Number.isFinite(initialCount)) {
      window.__bbePrevCartItemCount = initialCount
    }
  })
  document.addEventListener(
    "DOMContentLoaded",
    () => {
      if (typeof window.__bbePrevCartItemCount !== "undefined") return
      const fallback = Number(window.liquidAjaxCart?.cart?.item_count)
      if (Number.isFinite(fallback)) {
        window.__bbePrevCartItemCount = fallback
      }
    },
    { once: true },
  )
}

initiateGifts()

liquidAjaxCart.conf("updateOnWindowFocus", false)
// Allow qty 0 so minus at 1 removes the line (default keeps minus disabled at 1).
liquidAjaxCart.conf("quantityTagAllowZero", true)
liquidAjaxCart.conf("mutations", [CartGiftMutation, tryBeforeYouBuy])
